import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import DestinationDetail from "@/pages/DestinationDetail";
import OtherDestinations from "@/pages/OtherDestinations";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import QuoteForm from "@/pages/QuoteForm";
import MentionsLegales from "@/pages/MentionsLegales";
import CGV from "@/pages/CGV";
import Privacy from "@/pages/Privacy";
import About from "@/pages/About";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/destinations/:slug" element={<DestinationDetail />} />
            <Route path="/autres-destinations" element={<OtherDestinations />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/demande-de-devis" element={<QuoteForm />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/politique-de-confidentialite" element={<Privacy />} />
            <Route path="/qui-sommes-nous" element={<About />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
